import client from "./client";
import { NotificationInterface } from "../models/notification";

class NotificationService {
  async Get() {
    try {
      let url = `/api/TicketNotifications`;
      const { data } = await client.get<NotificationInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async MarkNotificationRead(
    notificationId: string
  ): Promise<NotificationInterface> {
    try {
      let url = `/api/TicketNotifications/${notificationId}`;
      const response = await client.post<NotificationInterface>(url);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async MarkAllNotificationRead(): Promise<NotificationInterface[]> {
    try {
      let url = `/api/TicketNotifications/ReadAll`;
      const response = await client.post(url, { url: "" });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new NotificationService();
